import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import HomeIcon from "@mui/icons-material/Home";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: "3rem 2rem",
  textAlign: "center",
  maxWidth: "600px",
  margin: "0 auto",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
  borderRadius: "12px",
}));

const IconContainer = styled(Box)(({ theme }) => ({
  marginBottom: "1.5rem",
  "& .MuiSvgIcon-root": {
    fontSize: "4rem",
    color: theme.palette.error.main,
    opacity: 0.7,
  },
}));

const Title = styled(Typography)(({ theme }) => ({
  marginBottom: "1rem",
  fontWeight: 600,
  color: "#1e2420",
}));

const Description = styled(Typography)(({ theme }) => ({
  marginBottom: "2rem",
  color: "#656b74",
  lineHeight: 1.6,
}));

const ServerError = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "calc(100vh - 8rem)",
        padding: "2rem",
      }}
    >
      <StyledPaper elevation={0} variant="outlined">
        <IconContainer>
          <ReportProblemIcon />
        </IconContainer>

        <Title variant="h4">{t("server_error.title")}</Title>

        <Description variant="body1">{t("server_error.description")}</Description>

        <Button component={Link} to="/" variant="contained" startIcon={<HomeIcon />}>
          {t("server_error.go_home")}
        </Button>
      </StyledPaper>
    </Box>
  );
};

export default ServerError;
